import {
    OptionRowValue,
    OptionRowValueItem
} from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import React, { useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    options: {
        menuItem: OptionRowValueItem;
        element: React.ReactNode;
    }[];
    onSelected?: (newIndex: number) => void;
    initialSelectedIndex: number;
    className?: string;
}

export const OptionRowComponentSwitch = (props: Props): JSX.Element => {
    const [currentIndex, setCurrentIndex] = useState(props.initialSelectedIndex);

    const menuItems = props.options.map((option) => option.menuItem);

    return (
        <S_OptionRowComponentSwitch className={props.className}>
            <SidebarSectionRow>
                <OptionRowValue
                    items={menuItems}
                    selectedIndex={currentIndex}
                    onSelected={(newIndex) => {
                        setCurrentIndex(newIndex);
                        props.onSelected?.(newIndex);
                    }}
                />
            </SidebarSectionRow>

            {props.options[currentIndex] && <>{props.options[currentIndex].element}</>}
        </S_OptionRowComponentSwitch>
    );
};

const S_OptionRowComponentSwitch = styled.div``;
